import { Spark } from './Brand.jsx';

export default function VeraRail({ onDismiss }) {
  return (
    <aside className="assistant-rail" aria-label="Vera, coming soon">
      <section className="vera-hero vera-teaser">
        <div className="vera-hero__wash" aria-hidden="true" />

        <div className="vera-hero__top">
          <span className="vera-avatar"><Spark size={22} /></span>
          <span className="vera-hero__id">
            <strong>Vera</strong>
            <span className="vera-coming-soon">Coming soon</span>
          </span>
          <button
            type="button"
            className="vera-dismiss"
            aria-label="Hide the Vera preview"
            title="Hide the Vera preview"
            onClick={onDismiss}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <div className="vera-teaser__body">
          <span className="vera-teaser__spark" aria-hidden="true"><Spark size={34} /></span>
          <span className="cap">A Presto Studio preview</span>
          <h2>Meet Vera.</h2>
          <p className="vera-teaser__lead">Your design and server assistant is coming soon.</p>
          <p className="vera-teaser__copy">
            A simpler way to shape your sites and care for everything behind them, right inside your studio.
          </p>
        </div>
      </section>

      <footer className="vera-teaser__foot">
        <Spark size={14} />
        <span>Coming soon to Presto Studio</span>
      </footer>
    </aside>
  );
}
